import { REQUEST_DELETE_FUNNEL, DELETE_FUNNEL_SUCCESS, DELETE_FUNNEL_ERROR } from './actionTypes';

export const requestDeleteFunnel = () => ({ type: REQUEST_DELETE_FUNNEL });

export const deleteFunnelSuccess = funnel => ({ type: DELETE_FUNNEL_SUCCESS, payload: funnel });

export const deleteFunnelError = error => ({ type: DELETE_FUNNEL_ERROR, payload: error });
